var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.56 51.7601C76.72 50.5601 76.8 49.3201 76.8 48.0001C76.8 46.7201 76.72 45.4401 76.52 44.2401L84.64 37.9201C85.36 37.3601 85.56 36.2801 85.12 35.4801L77.44 22.2001C76.96 21.3201 75.96 21.0401 75.08 21.3201L65.5199 25.1601C63.5199 23.6401 61.4 22.3601 59.04 21.4001L57.5999 11.2401C57.4399 10.2801 56.64 9.6001 55.68 9.6001H40.32C39.36 9.6001 38.5999 10.2801 38.4399 11.2401L37 21.4001C34.64 22.3601 32.48 23.6801 30.52 25.1601L20.9599 21.3201C20.0799 21.0001 19.08 21.3201 18.6 22.2001L10.96 35.4801C10.48 36.3201 10.64 37.3601 11.44 37.9201L19.5599 44.2401C19.3599 45.4401 19.2 46.7601 19.2 48.0001C19.2 49.2401 19.2799 50.5601 19.4799 51.7601L11.36 58.0801C10.64 58.6401 10.44 59.7201 10.88 60.5201L18.5599 73.8001C19.0399 74.6801 20.04 74.9601 20.92 74.6801L30.4799 70.8401C32.4799 72.3601 34.5999 73.6401 36.9599 74.6001L38.4 84.7601C38.6 85.7201 39.36 86.4001 40.32 86.4001H55.68C56.64 86.4001 57.44 85.7201 57.56 84.7601L59 74.6001C61.36 73.6401 63.52 72.3601 65.48 70.8401L75.04 74.6801C75.92 75.0001 76.92 74.6801 77.4 73.8001L85.08 60.5201C85.56 59.6401 85.36 58.6401 84.6 58.0801L76.56 51.7601ZM48 62.4001C40.08 62.4001 33.5999 55.9201 33.5999 48.0001C33.5999 40.0801 40.08 33.6001 48 33.6001C55.92 33.6001 62.4 40.0801 62.4 48.0001C62.4 55.9201 55.92 62.4001 48 62.4001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b0f83ec16bbf8fb79079999f3e672f39.svg";
export { ForwardRef as ReactComponent };